import { ErrorToast } from "../components/toastify";
import { AxiosPostMethod } from "../helpers/customAxios";

const HandleLogin = async (body) => {
  const formData = new FormData();
  formData.set("username", body.username);
  formData.set("password", body.password);
  const loginRes = await AxiosPostMethod("entry/login", formData, true);
  if (loginRes.status === 200) {
    return loginRes.data.data;
  } else if (loginRes.status === 401) {
    ErrorToast("Username or Password incorrect");
  } else {
    ErrorToast("Error Occured on Login. Please contact admin");
  }
};
export default HandleLogin;
